import socketio from 'socket.io-client';

export default {
  /**
  * Socket service
  *
  * @param store
  * @type {{connect: (function(store))}}
  */
  connect(store) {
    const { url } = window.sevenConfig.backends.scm;
    const options = {
      query: `token=token&clientType=user&clientSubType=Operator&token=${window.sevenConfig.user.auth.accessToken}`,
      forceNew: true,
      transports: ['websocket'],
    };

    const sio = socketio(url, options);
    /**
     * Subscribe to channel
     */
    sio.on('connect', () => {
      sio.emit('subscribe', {
        channel: window.sevenConfig.product.cpvUuid,
        subChannels: {
          language: window.sevenConfig.company.language,
          deliveryPlatform: 'Retail',
          deviceUuid: window.sevenConfig.device.uuid,
        },
      });
      sio.on(window.sevenConfig.product.cpvUuid,
        (message) => {
          store.dispatch('socketMessage', message);
        });
    });
    sio.on('system', (systemMessage) => {
      if (systemMessage.type === 'keepAlive') {
        store.dispatch('socketMessage', systemMessage);
      }
    });
    /**
     * Disconnect
     */
    sio.on('disconnect', () => {
      store.dispatch('setSocketConnect', false);
    });
  },
};
